var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.66634 2C9.34605 2 10.957 2.66726 12.1447 3.85499C13.3324 5.04272 13.9997 6.65363 13.9997 8.33333C13.9997 10.013 13.3324 11.6239 12.1447 12.8117C10.957 13.9994 9.34605 14.6667 7.66634 14.6667C5.98664 14.6667 4.37573 13.9994 3.188 12.8117C2.00027 11.6239 1.33301 10.013 1.33301 8.33333C1.33301 6.65363 2.00027 5.04272 3.188 3.85499C4.37573 2.66726 5.98664 2 7.66634 2ZM7.66634 2.66667C6.16345 2.66667 4.72211 3.26369 3.6594 4.3264C2.5967 5.3891 1.99967 6.83044 1.99967 8.33333C1.99967 9.83623 2.5967 11.2776 3.6594 12.3403C4.72211 13.403 6.16345 14 7.66634 14C8.4105 14 9.14737 13.8534 9.83488 13.5687C10.5224 13.2839 11.1471 12.8665 11.6733 12.3403C12.1995 11.8141 12.6169 11.1894 12.9017 10.5019C13.1864 9.81436 13.333 9.07749 13.333 8.33333C13.333 6.83044 12.736 5.3891 11.6733 4.3264C10.6106 3.26369 9.16923 2.66667 7.66634 2.66667ZM7.33301 4.66667H7.99967V8.28L11.133 10.0867L10.7997 10.6667L7.33301 8.66667V4.66667Z",
    fill: "#213332",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightClock);
export default __webpack_public_path__ + "static/media/light_clock.d67f57f3789caef973c292857908c871.svg";
export { ForwardRef as ReactComponent };